import { fsmData } from '../../../universal';
import { React, _ } from '../../lib';
export const TextSearched = (props) => {
    if (!props.needles || props.needles.length == 0) {
        return React.createElement(React.Fragment, null, props.text);
    }
    const defaultClassName = props.tailwind ? 'bg-[#ff0] text-[#000] font-bold' : '';
    const text = props.text.toLowerCase();
    const needles = fsmData(normaliseNeedles(props.needles), {
        filter: _.identity,
        map: x => x.toLowerCase(),
    });
    const matches = [];
    _.forEach(needles, needle => {
        let index = text.indexOf(needle);
        while (index !== -1) {
            matches.push({ start: index, end: index + needle.length });
            index = text.indexOf(needle, index + 1);
        }
    });
    if (matches.length == 0) {
        return React.createElement(React.Fragment, null, props.text);
    }
    const matchesCombined = [];
    matches.sort((a, b) => a.start - b.start);
    _.forEach(matches, match => {
        if (matchesCombined.length == 0) {
            matchesCombined.push(match);
            return;
        }
        const last = matchesCombined[matchesCombined.length - 1];
        if (last == undefined) {
            return;
        }
        else if (match.start <= last.end) {
            last.end = _.max([match.end, last.end]) ?? -1;
        }
        else {
            matchesCombined.push(match);
        }
    });
    const segments = [];
    let lastIndex = 0;
    _.forEach(matchesCombined, match => {
        if (match.start != lastIndex) {
            segments.push(React.createElement(React.Fragment, { key: lastIndex }, props.text.slice(lastIndex, match.start)));
        }
        segments.push(React.createElement("em", { key: match.start, className: props.className ?? defaultClassName }, props.text.slice(match.start, match.end)));
        lastIndex = match.end;
    });
    if (lastIndex != props.text.length) {
        segments.push(React.createElement(React.Fragment, { key: lastIndex }, props.text.slice(lastIndex, props.text.length)));
    }
    return React.createElement(React.Fragment, null, segments);
};
export const searchText = (text, needles, requireAll = false) => {
    if (!needles || needles.length == 0) {
        return true;
    }
    text = text.toLowerCase();
    needles = fsmData(normaliseNeedles(needles), {
        filter: _.identity,
        map: x => x.toLowerCase(),
    });
    if (needles.length == 0) {
        return true;
    }
    const found = _.uniq(_.map(needles, needle => text.indexOf(needle) != -1));
    return requireAll ? !found.includes(false) : found.includes(true);
};
const normaliseNeedles = (needles) => {
    if (!needles) {
        return [];
    }
    if (_.isArray(needles)) {
        return needles;
    }
    return (needles ?? '').split(/\s+/).filter(x => x);
};
export const StubText = (props) => (React.createElement("div", { className: "w-full h-full pt-5 bg-neutral-200" },
    React.createElement("div", { className: "text-center font-light text-2xl text-neutral-500" }, props.children)));
//# sourceMappingURL=text.js.map